/**
 * useAuthUser Hook
 * Gets user data from secure encrypted storage
 */
import secureStorage from '../utils/security/secureStorage';

const useAuthUser = () => {
    try {
        // User data is stored encrypted in secureStorage
        const user = secureStorage.getItem("user");
        return user || null;
    } catch (error) {
        console.error("Error retrieving user from storage");
        return null;
    }
};

export default useAuthUser;
